import type { IssueViewModel } from '@trinnvis/dabih-api-client';
import type { IssueViewModelExtended } from './issue-view-model-extended';
import { isIssueProcessed } from './is-issue-processed';
import { _formatDate } from '../utilities/_formatDate';

export function toIssueViewModel(item: IssueViewModel): IssueViewModelExtended {
  return Object.assign({}, item, {
    reportedDateFormatted: _formatDate(item.reportedDate?.toString()),
    status: isIssueProcessed(item) ? 'ferdigbehandlet' : 'aktiv',
  });
}
